import { IAccount } from '../models/Account/IAccount';
import { IAddress } from '../models/Account/IAddress';
import { IAuthChange } from '../models/Account/IAuthChange';
import { ICommPreference } from '../models/Account/ICommPreference';
import { IContactConfig } from '../models/Account/IContactConfig';
import { IContactEdit } from '../models/Account/IContactEdit';
import { IPhone } from '../models/Account/IPhone';
import { IBasicItem } from '../models/IBasicItem';

function accountServiceMock() {
  function getAccount(): any {
    const accountData: any = {
      memberId: '657340-SH',
      labelName: 'Glenn Hickman',
      userEmail: 'glenn.hickman@shrm.org',
      membershipExpirationLabel: 'Membership Expires: ',
      membershipExpirationDate: '12/31/2023',
      ssoEmail: 'ryan.adams.082601@shrm.org',
      membershipType: 'Professional',
      membershipCategory: null,
      manageMembershipUrl: 'https://dev-nsstore.shrm.org/shrm-dev-kilimanjaro/my_account.ssp',
      manageCreditCardsUrl:
        'https://dev-nsstore.shrm.org/shrm-dev-kilimanjaro/my_account.ssp#creditcards',
      joinMembershipUrl: 'https://dev-nsstore.shrm.org/join',
      renewMembershipUrl: 'https://dev-nsstore.shrm.org/membership',
      renewalModel: null,
      isCreditCardWidgetActive: true,
      isAutoRenewalWidgetActive: false,
      renewalMembershipDate: 'February 01, 2023',
      addresses: [
        {
          addressLine1: '1800 Duke St',
          addressLine2: 'Second line',
          addressee: 'Dejan Mancic',
          city: 'Ale',
          contactEntryType: 1,
          contactLocation: 0,
          countryCode: 'US',
          countryDescription: null,
          customerAddressId: '8547437',
          isBilling: true,
          isPrimary: false,
          isShipping: false,
          mailStop: '',
          postalCode: '22314-3494',
          state: 'VA',
        },
        {
          addressLine1: '1800 Duke St',
          addressLine2: '',
          addressee: 'Dejan Mancic',
          city: 'Ale',
          contactEntryType: 1,
          contactLocation: 0,
          countryCode: 'US',
          countryDescription: null,
          customerAddressId: '8547437',
          isBilling: true,
          isPrimary: false,
          isShipping: true,
          mailStop: '',
          postalCode: '22314-3494',
          state: 'VA',
        },
      ],
      phones: [
        {
          contactEntryType: 4,
          contactLocation: 1,
          formattedNumber: '(1)123-4567 x 123',
          isPrimary: false,
          phoneCode: 'US',
          phoneCountryCode: '1',
          phoneCountryCodeId: '241',
          phoneExtension: '123',
          phoneNumber: '1234567',
        },
        {
          contactEntryType: 4,
          contactLocation: 2,
          formattedNumber: '(1)333-4455 x 234',
          isPrimary: true,
          phoneCode: 'IN',
          phoneCountryCode: '1',
          phoneCountryCodeId: '241',
          phoneExtension: '123',
          phoneNumber: '7654321',
        },
        {
          contactEntryType: 4,
          contactLocation: 3,
          formattedNumber: '(1)333-4455 x 234',
          isPrimary: true,
          phoneCode: 'IN',
          phoneCountryCode: '1',
          phoneCountryCodeId: '241',
          phoneExtension: '123',
          phoneNumber: '7654321',
        },
        {
          contactEntryType: 4,
          contactLocation: 4,
          formattedNumber: '(1)333-4455 x 234',
          isPrimary: true,
          phoneCode: 'IN',
          phoneCountryCode: '1',
          phoneCountryCodeId: '241',
          phoneExtension: '123',
          phoneNumber: '7654321',
        },
      ],
      commPreferenceModel: {
        allowEmail: true,
        allowPostalMail: true,
        allowPhone: true,
        allowFax: false,
        allowThirdParty: true,
        allowSolicitation: true,
      },
      hrMagazineSubscriptionEnabled: false,
      hrMagazineSubscriptionType: 0,
      specialtyCredentials: [
        {
          itemName: 'SHRM U.S. Employment Immigration Specialty Credential',
          expirationDate: '6/4/2025',
        },
        {
          itemName: 'SHRM U.S. Employment Immigration Specialty Credential',
          expirationDate: '6/4/2025',
        },
        {
          itemName: 'SHRM U.S. Employment Immigration Specialty Credential',
          expirationDate: '6/4/2025',
        },
        {
          itemName: 'SHRM U.S. Employment Immigration Specialty Credential',
          expirationDate: '6/4/2025',
        },
        {
          itemName: 'SHRM U.S. Employment Immigration Specialty Credential',
          expirationDate: '6/4/2025',
        },
      ],
      customerQualifications: [
        { itemName: 'SHRM People Manager Qualification (PMQ)', expirationDate: '4/3/2023' },
        { itemName: 'SHRM People Manager Qualification (PMQ)', expirationDate: '4/3/2023' },
      ],
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: accountData,
      });
      throw new Error('Mock exception!');
    });
  }

  function getMembershipCertificateData(memberId: string, ssoUUId: string) {
    return new Promise((resolve, reject) => {
      resolve({
        data: '',
      });
      throw new Error('Mock exception!');
    });
  }
  function getContactEditData() {
    const contactEditData: IContactEdit = {
      contactEntries: [
        { value: '0', label: 'Undefined' },
        { value: '1', label: 'Address' },
        { value: '2', label: 'Email' },
        { value: '3', label: 'Fax' },
        { value: '4', label: 'Phone' },
      ],
      contactLocations: [
        { value: '0', label: 'Undefined' },
        { value: '1', label: 'Business' },
        { value: '2', label: 'Home' },
        { value: '3', label: 'School' },
        { value: '4', label: 'Cell' },
      ],
      countries: [
        { value: 'AF', label: 'Afghanistan' },
        { value: 'AX', label: 'Aland Islands' },
        { value: 'AL', label: 'Albania' },
        { value: 'DZ', label: 'Algeria' },
        { value: 'AS', label: 'American Samoa' },
        { value: 'AD', label: 'Andorra' },
        { value: 'AO', label: 'Angola' },
        { value: 'AI', label: 'Anguilla' },
        { value: 'AQ', label: 'Antarctica' },
        { value: 'AG', label: 'Antigua and Barbuda' },
        { value: 'AR', label: 'Argentina' },
        { value: 'AM', label: 'Armenia' },
        { value: 'AW', label: 'Aruba' },
        { value: 'AU', label: 'Australia' },
        { value: 'AT', label: 'Austria' },
        { value: 'AZ', label: 'Azerbaijan' },
        { value: 'BS', label: 'Bahamas' },
        { value: 'BH', label: 'Bahrain' },
        { value: 'BD', label: 'Bangladesh' },
        { value: 'BB', label: 'Barbados' },
        { value: 'BY', label: 'Belarus' },
        { value: 'BE', label: 'Belgium' },
        { value: 'BZ', label: 'Belize' },
        { value: 'BJ', label: 'Benin' },
        { value: 'BM', label: 'Bermuda' },
        { value: 'BT', label: 'Bhutan' },
        { value: 'BO', label: 'Bolivia' },
        { value: 'BQ', label: 'Bonaire, Saint Eustatius and Saba' },
        { value: 'BA', label: 'Bosnia and Herzegovina' },
        { value: 'BW', label: 'Botswana' },
        { value: 'BV', label: 'Bouvet Island' },
        { value: 'BR', label: 'Brazil' },
        { value: 'IO', label: 'British Indian Ocean Territory' },
        { value: 'BN', label: 'Brunei Darussalam' },
        { value: 'BG', label: 'Bulgaria' },
        { value: 'BF', label: 'Burkina Faso' },
        { value: 'BI', label: 'Burundi' },
        { value: 'KH', label: 'Cambodia' },
        { value: 'CM', label: 'Cameroon' },
        { value: 'CA', label: 'Canada' },
        { value: 'IC', label: 'Canary Islands' },
        { value: 'CV', label: 'Cape Verde' },
        { value: 'KY', label: 'Cayman Islands' },
        { value: 'CF', label: 'Central African Republic' },
        { value: 'EA', label: 'Ceuta and Melilla' },
        { value: 'TD', label: 'Chad' },
        { value: 'CL', label: 'Chile' },
        { value: 'CN', label: 'China' },
        { value: 'CX', label: 'Christmas Island' },
        { value: 'CC', label: 'Cocos (Keeling) Islands' },
        { value: 'CO', label: 'Colombia' },
        { value: 'KM', label: 'Comoros' },
        { value: 'CD', label: 'Congo, Democratic Republic of' },
        { value: 'CG', label: 'Congo, Republic of' },
        { value: 'CK', label: 'Cook Islands' },
        { value: 'CR', label: 'Costa Rica' },
        { value: 'CI', label: "Cote d'Ivoire" },
        { value: 'HR', label: 'Croatia/Hrvatska' },
        { value: 'CU', label: 'Cuba' },
        { value: 'CW', label: 'Cura�ao' },
        { value: 'CY', label: 'Cyprus' },
        { value: 'CZ', label: 'Czech Republic' },
        { value: 'DK', label: 'Denmark' },
        { value: 'DJ', label: 'Djibouti' },
        { value: 'DM', label: 'Dominica' },
        { value: 'DO', label: 'Dominican Republic' },
        { value: 'TL', label: 'East Timor' },
        { value: 'EC', label: 'Ecuador' },
        { value: 'EG', label: 'Egypt' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'GQ', label: 'Equatorial Guinea' },
        { value: 'ER', label: 'Eritrea' },
        { value: 'EE', label: 'Estonia' },
        { value: 'ET', label: 'Ethiopia' },
        { value: 'FK', label: 'Falkland Islands' },
        { value: 'FO', label: 'Faroe Islands' },
        { value: 'FJ', label: 'Fiji' },
        { value: 'FI', label: 'Finland' },
        { value: 'FR', label: 'France' },
        { value: 'GF', label: 'French Guiana' },
        { value: 'PF', label: 'French Polynesia' },
        { value: 'TF', label: 'French Southern Territories' },
        { value: 'GA', label: 'Gabon' },
        { value: 'GM', label: 'Gambia' },
        { value: 'GE', label: 'Georgia' },
        { value: 'DE', label: 'Germany' },
        { value: 'GH', label: 'Ghana' },
        { value: 'GI', label: 'Gibraltar' },
        { value: 'GR', label: 'Greece' },
        { value: 'GL', label: 'Greenland' },
        { value: 'GD', label: 'Grenada' },
        { value: 'GP', label: 'Guadeloupe' },
        { value: 'GU', label: 'Guam' },
        { value: 'GT', label: 'Guatemala' },
        { value: 'GG', label: 'Guernsey' },
        { value: 'GN', label: 'Guinea' },
        { value: 'GW', label: 'Guinea-Bissau' },
        { value: 'GY', label: 'Guyana' },
        { value: 'HT', label: 'Haiti' },
        { value: 'HM', label: 'Heard and McDonald Islands' },
        { value: 'VA', label: 'Holy See (City Vatican State)' },
        { value: 'HN', label: 'Honduras' },
        { value: 'HK', label: 'Hong Kong' },
        { value: 'HU', label: 'Hungary' },
        { value: 'IS', label: 'Iceland' },
        { value: 'IN', label: 'India' },
        { value: 'ID', label: 'Indonesia' },
        { value: 'IR', label: 'Iran (Islamic Republic of)' },
        { value: 'IQ', label: 'Iraq' },
        { value: 'IE', label: 'Ireland' },
        { value: 'IM', label: 'Isle of Man' },
        { value: 'IL', label: 'Israel' },
        { value: 'IT', label: 'Italy' },
        { value: 'JM', label: 'Jamaica' },
        { value: 'JP', label: 'Japan' },
        { value: 'JE', label: 'Jersey' },
        { value: 'JO', label: 'Jordan' },
        { value: 'KZ', label: 'Kazakhstan' },
        { value: 'KE', label: 'Kenya' },
        { value: 'KI', label: 'Kiribati' },
        { value: 'KP', label: "Korea, Democratic People's Republic" },
        { value: 'KR', label: 'Korea, Republic of' },
        { value: 'XK', label: 'Kosovo' },
        { value: 'KW', label: 'Kuwait' },
        { value: 'KG', label: 'Kyrgyzstan' },
        { value: 'LA', label: "Lao People's Democratic Republic" },
        { value: 'LV', label: 'Latvia' },
        { value: 'LB', label: 'Lebanon' },
        { value: 'LS', label: 'Lesotho' },
        { value: 'LR', label: 'Liberia' },
        { value: 'LY', label: 'Libya' },
        { value: 'LI', label: 'Liechtenstein' },
        { value: 'LT', label: 'Lithuania' },
        { value: 'LU', label: 'Luxembourg' },
        { value: 'MO', label: 'Macau' },
        { value: 'MK', label: 'Macedonia' },
        { value: 'MG', label: 'Madagascar' },
        { value: 'MW', label: 'Malawi' },
        { value: 'MY', label: 'Malaysia' },
        { value: 'MV', label: 'Maldives' },
        { value: 'ML', label: 'Mali' },
        { value: 'MT', label: 'Malta' },
        { value: 'MH', label: 'Marshall Islands' },
        { value: 'MQ', label: 'Martinique' },
        { value: 'MR', label: 'Mauritania' },
        { value: 'MU', label: 'Mauritius' },
        { value: 'YT', label: 'Mayotte' },
        { value: 'MX', label: 'Mexico' },
        { value: 'FM', label: 'Micronesia, Federal State of' },
        { value: 'MD', label: 'Moldova, Republic of' },
        { value: 'MC', label: 'Monaco' },
        { value: 'MN', label: 'Mongolia' },
        { value: 'ME', label: 'Montenegro' },
        { value: 'MS', label: 'Montserrat' },
        { value: 'MA', label: 'Morocco' },
        { value: 'MZ', label: 'Mozambique' },
        { value: 'MM', label: 'Myanmar (Burma)' },
        { value: 'NA', label: 'Namibia' },
        { value: 'NR', label: 'Nauru' },
        { value: 'NP', label: 'Nepal' },
        { value: 'NL', label: 'Netherlands' },
        { value: 'AN', label: 'Netherlands Antilles (Deprecated)' },
        { value: 'NC', label: 'New Caledonia' },
        { value: 'NZ', label: 'New Zealand' },
        { value: 'NI', label: 'Nicaragua' },
        { value: 'NE', label: 'Niger' },
        { value: 'NG', label: 'Nigeria' },
        { value: 'NU', label: 'Niue' },
        { value: 'NF', label: 'Norfolk Island' },
        { value: 'MP', label: 'Northern Mariana Islands' },
        { value: 'NO', label: 'Norway' },
        { value: 'OM', label: 'Oman' },
        { value: 'PK', label: 'Pakistan' },
        { value: 'PW', label: 'Palau' },
        { value: 'PA', label: 'Panama' },
        { value: 'PG', label: 'Papua New Guinea' },
        { value: 'PY', label: 'Paraguay' },
        { value: 'PE', label: 'Peru' },
        { value: 'PH', label: 'Philippines' },
        { value: 'PN', label: 'Pitcairn Island' },
        { value: 'PL', label: 'Poland' },
        { value: 'PT', label: 'Portugal' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'QA', label: 'Qatar' },
        { value: 'RE', label: 'Reunion Island' },
        { value: 'RO', label: 'Romania' },
        { value: 'RU', label: 'Russian Federation' },
        { value: 'RW', label: 'Rwanda' },
        { value: 'BL', label: 'Saint Barth�lemy' },
        { value: 'SH', label: 'Saint Helena' },
        { value: 'KN', label: 'Saint Kitts and Nevis' },
        { value: 'LC', label: 'Saint Lucia' },
        { value: 'MF', label: 'Saint Martin' },
        { value: 'VC', label: 'Saint Vincent and the Grenadines' },
        { value: 'WS', label: 'Samoa' },
        { value: 'SM', label: 'San Marino' },
        { value: 'ST', label: 'Sao Tome and Principe' },
        { value: 'SA', label: 'Saudi Arabia' },
        { value: 'SN', label: 'Senegal' },
        { value: 'RS', label: 'Serbia' },
        { value: 'CS', label: 'Serbia and Montenegro (Deprecated)' },
        { value: 'SC', label: 'Seychelles' },
        { value: 'SL', label: 'Sierra Leone' },
        { value: 'SG', label: 'Singapore' },
        { value: 'SX', label: 'Sint Maarten' },
        { value: 'SK', label: 'Slovak Republic' },
        { value: 'SI', label: 'Slovenia' },
        { value: 'SB', label: 'Solomon Islands' },
        { value: 'SO', label: 'Somalia' },
        { value: 'ZA', label: 'South Africa' },
        { value: 'GS', label: 'South Georgia' },
        { value: 'SS', label: 'South Sudan' },
        { value: 'ES', label: 'Spain' },
        { value: 'LK', label: 'Sri Lanka' },
        { value: 'PM', label: 'St. Pierre and Miquelon' },
        { value: 'PS', label: 'State of Palestine' },
        { value: 'SD', label: 'Sudan' },
        { value: 'SR', label: 'Suriname' },
        { value: 'SJ', label: 'Svalbard and Jan Mayen Islands' },
        { value: 'SZ', label: 'Swaziland' },
        { value: 'SE', label: 'Sweden' },
        { value: 'CH', label: 'Switzerland' },
        { value: 'SY', label: 'Syrian Arab Republic' },
        { value: 'TW', label: 'Taiwan' },
        { value: 'TJ', label: 'Tajikistan' },
        { value: 'TZ', label: 'Tanzania' },
        { value: 'TH', label: 'Thailand' },
        { value: 'TG', label: 'Togo' },
        { value: 'TK', label: 'Tokelau' },
        { value: 'TO', label: 'Tonga' },
        { value: 'TT', label: 'Trinidad and Tobago' },
        { value: 'TN', label: 'Tunisia' },
        { value: 'TR', label: 'Turkey' },
        { value: 'TM', label: 'Turkmenistan' },
        { value: 'TC', label: 'Turks and Caicos Islands' },
        { value: 'TV', label: 'Tuvalu' },
        { value: 'UG', label: 'Uganda' },
        { value: 'UA', label: 'Ukraine' },
        { value: 'AE', label: 'United Arab Emirates' },
        { value: 'GB', label: 'United Kingdom' },
        { value: 'US', label: 'United States' },
        { value: 'UY', label: 'Uruguay' },
        { value: 'UM', label: 'US Minor Outlying Islands' },
        { value: 'UZ', label: 'Uzbekistan' },
        { value: 'VU', label: 'Vanuatu' },
        { value: 'VE', label: 'Venezuela' },
        { value: 'VN', label: 'Vietnam' },
        { value: 'VG', label: 'Virgin Islands (British)' },
        { value: 'VI', label: 'Virgin Islands (USA)' },
        { value: 'WF', label: 'Wallis and Futuna' },
        { value: 'EH', label: 'Western Sahara' },
        { value: 'YE', label: 'Yemen' },
        { value: 'ZM', label: 'Zambia' },
        { value: 'ZW', label: 'Zimbabwe' },
      ],
      states: [
        { value: 'AA', label: 'Armed Forces Americas' },
        { value: 'AE', label: 'Armed Forces Europe' },
        { value: 'AK', label: 'Alaska' },
        { value: 'AL', label: 'Alabama' },
        { value: 'AP', label: 'Armed Forces Pacific' },
        { value: 'AR', label: 'Arkansas' },
        { value: 'AZ', label: 'Arizona' },
        { value: 'CA', label: 'California' },
        { value: 'CO', label: 'Colorado' },
        { value: 'CT', label: 'Connecticut' },
        { value: 'DC', label: 'District of Columbia' },
        { value: 'DE', label: 'Delaware' },
        { value: 'FL', label: 'Florida' },
        { value: 'GA', label: 'Georgia' },
        { value: 'GU', label: 'US Territories-Guam' },
        { value: 'HI', label: 'Hawaii' },
        { value: 'IA', label: 'Iowa' },
        { value: 'ID', label: 'Idaho' },
        { value: 'IL', label: 'Illinois' },
        { value: 'IN', label: 'Indiana' },
        { value: 'KS', label: 'Kansas' },
        { value: 'KY', label: 'Kentucky' },
        { value: 'LA', label: 'Louisiana' },
        { value: 'MA', label: 'Massachusetts' },
        { value: 'MD', label: 'Maryland' },
        { value: 'ME', label: 'Maine' },
        { value: 'MI', label: 'Michigan' },
        { value: 'MN', label: 'Minnesota' },
        { value: 'MO', label: 'Missouri' },
        { value: 'MP', label: 'US Territories-Northern Marian' },
        { value: 'MS', label: 'Mississippi' },
        { value: 'MT', label: 'Montana' },
        { value: 'NC', label: 'North Carolina' },
        { value: 'ND', label: 'North Dakota' },
        { value: 'NE', label: 'Nebraska' },
        { value: 'NH', label: 'New Hampshire' },
        { value: 'NJ', label: 'New Jersey' },
        { value: 'NM', label: 'New Mexico' },
        { value: 'NV', label: 'Nevada' },
        { value: 'NY', label: 'New York' },
        { value: 'OH', label: 'Ohio' },
        { value: 'OK', label: 'Oklahoma' },
        { value: 'OR', label: 'Oregon' },
        { value: 'PA', label: 'Pennsylvania' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'RI', label: 'Rhode Island' },
        { value: 'SC', label: 'South Carolina' },
        { value: 'SD', label: 'South Dakota' },
        { value: 'TN', label: 'Tennessee' },
        { value: 'TX', label: 'Texas' },
        { value: 'UT', label: 'Utah' },
        { value: 'VA', label: 'Virginia' },
        { value: 'VT', label: 'Vermont' },
        { value: 'WA', label: 'Washington' },
        { value: 'WI', label: 'Wisconsin' },
        { value: 'WV', label: 'West Virginia' },
        { value: 'WY', label: 'Wyoming' },
      ],
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: contactEditData,
      });
      throw new Error('Mock exception!');
    });
  }

  function getContactConfigData(countryCode: string) {
    const contactConfigData: IContactConfig = {
      addressConfigModel: {
        panelAddressLine1Visible: true,
        panelAddressLine2Visible: true,
        panelAddressLine3Visible: true,
        panelAddressLine4Visible: false,
        panelPostCodeVisible: true,
        panelCityVisible: true,
        panelStateVisible: true,
        panelStateAsTextVisible: false,
        validatePostalCodeVisible: true,
        validatePostalCodeRequiredVisible: true,
        addressLine1Label: 'Address Line 1',
        addressLine2Label: 'Address Line 2',
        addressLine3Label: 'Address Line 3',
        addressLine4Label: null,
        cityLabel: 'City',
        stateLabel: 'State',
        postalCodeLabel: 'Zip Code',
        stateAsTextMaxLength: 0,
        addressLine1MaxLength: 80,
        addressLine2MaxLength: 80,
        addressLine3MaxLength: 80,
        addressLine4MaxLength: 0,
        cityMaxLength: 40,
        postalCodeMaxLength: 15,
        addressLine1Required: true,
        addressLine2Required: false,
        addressLine3Required: false,
        addressLine4Required: false,
        cityRequired: true,
        stateRequired: true,
        postalCodeRequired: true,
      },
      phoneConfigModel: {
        phoneCountryCodeId: '241',
        phoneCountryCode: '1',
        phoneCountryCodeEnabled: true,
        phoneAreaCodeEnabled: true,
        phoneAreaCodeMaxLength: 3,
        phoneNumberEnabled: true,
        phoneNumberMaxLength: 15,
        phoneExtensionEnabled: true,
        phoneExtensionMaxLength: 8,
      },
      faxConfigModel: null,
    };

    return new Promise((resolve, reject) => {
      resolve({
        data: contactConfigData,
      });
      throw new Error('Mock exception!');
    });
  }

  function getStatesForCountry(countryCode: string) {
    const states: IBasicItem[] = [
      { value: 'AA', label: 'Armed Forces Americas' },
      { value: 'AE', label: 'Armed Forces Europe' },
      { value: 'AK', label: 'Alaska' },
      { value: 'AL', label: 'Alabama' },
      { value: 'AP', label: 'Armed Forces Pacific' },
      { value: 'AR', label: 'Arkansas' },
      { value: 'AZ', label: 'Arizona' },
      { value: 'CA', label: 'California' },
      { value: 'CO', label: 'Colorado' },
      { value: 'CT', label: 'Connecticut' },
      { value: 'DC', label: 'District of Columbia' },
      { value: 'DE', label: 'Delaware' },
      { value: 'FL', label: 'Florida' },
      { value: 'GA', label: 'Georgia' },
      { value: 'GU', label: 'US Territories-Guam' },
      { value: 'HI', label: 'Hawaii' },
      { value: 'IA', label: 'Iowa' },
      { value: 'ID', label: 'Idaho' },
      { value: 'IL', label: 'Illinois' },
      { value: 'IN', label: 'Indiana' },
      { value: 'KS', label: 'Kansas' },
      { value: 'KY', label: 'Kentucky' },
      { value: 'LA', label: 'Louisiana' },
      { value: 'MA', label: 'Massachusetts' },
      { value: 'MD', label: 'Maryland' },
      { value: 'ME', label: 'Maine' },
      { value: 'MI', label: 'Michigan' },
      { value: 'MN', label: 'Minnesota' },
      { value: 'MO', label: 'Missouri' },
      { value: 'MP', label: 'US Territories-Northern Marian' },
      { value: 'MS', label: 'Mississippi' },
      { value: 'MT', label: 'Montana' },
      { value: 'NC', label: 'North Carolina' },
      { value: 'ND', label: 'North Dakota' },
      { value: 'NE', label: 'Nebraska' },
      { value: 'NH', label: 'New Hampshire' },
      { value: 'NJ', label: 'New Jersey' },
      { value: 'NM', label: 'New Mexico' },
      { value: 'NV', label: 'Nevada' },
      { value: 'NY', label: 'New York' },
      { value: 'OH', label: 'Ohio' },
      { value: 'OK', label: 'Oklahoma' },
      { value: 'OR', label: 'Oregon' },
      { value: 'PA', label: 'Pennsylvania' },
      { value: 'PR', label: 'Puerto Rico' },
      { value: 'RI', label: 'Rhode Island' },
      { value: 'SC', label: 'South Carolina' },
      { value: 'SD', label: 'South Dakota' },
      { value: 'TN', label: 'Tennessee' },
      { value: 'TX', label: 'Texas' },
      { value: 'UT', label: 'Utah' },
      { value: 'VA', label: 'Virginia' },
      { value: 'VT', label: 'Vermont' },
      { value: 'WA', label: 'Washington' },
      { value: 'WI', label: 'Wisconsin' },
      { value: 'WV', label: 'West Virginia' },
      { value: 'WY', label: 'Wyoming' },
    ];

    return new Promise((resolve, reject) => {
      resolve({
        data: states,
      });
      throw new Error('Mock exception!');
    });
  }

  function saveAddress(id: string, data: IAddress) {
    return new Promise((resolve, reject) => {
      resolve({
        data: data,
      });
      throw new Error('Mock exception!');
    });
  }

  function saveEmailPassword(data: IAuthChange) {
    return new Promise((resolve, reject) => {
      resolve({
        data: data,
      });
      throw new Error('Mock exception!');
    });
  }

  function savePhone(id: string, data: IPhone) {
    return new Promise((resolve, reject) => {
      resolve({});
      throw new Error('Mock exception!');
    });
  }

  function getAllEntries<IEntry>(memberId: string, ssoUUId: string) {
    return new Promise((resolve, reject) => {
      resolve({});
      throw new Error('Mock exception!');
    });
  }

  function saveHrMagazineSubscription(memberId: string, editionType: number) {
    return new Promise((resolve, reject) => {
      resolve({});
      throw new Error('Mock exception!');
    });
  }

  function updatePreferences(memberId: string, commPreferences: ICommPreference) {
    return new Promise((resolve, reject) => {
      resolve({});
      throw new Error('Mock exception!');
    });
  }

  return {
    getAccount,
    getMembershipCertificateData,
    getContactEditData,
    getContactConfigData,
    getStatesForCountry,
    saveAddress,
    saveEmailPassword,
    savePhone,
    getAllEntries,
    saveHrMagazineSubscription,
    updatePreferences,
  };
}

export default accountServiceMock;
